import React from 'react'
import Helmet from 'react-helmet'
// import { useState } from 'react';
// import * as emailjs from 'emailjs-com'

import Gallery from '../components/Gallery'
import Layout from '../components/layout'
import '../assets/css/progress.css'
// import favicon from '../assets/images/favicon.ico'





const HomeIndex = () => {
  const siteTitle = "Ajay's Resume"
  const siteDescription = 'Resume Ajay Jangid'
  // const siteFavicon = favicon
  

  return (
    <Layout>
      <Helmet>
        <title>{siteTitle}</title>
        <meta name="description" content={siteDescription} />
        {/* <link rel="icon" href={siteFavicon}/> */}
      </Helmet>

      <div id="main">
        <section id="one">
          <header className="major">
            <h2>
              Welcome To My Portfolio Find below 
              <br />
              Industrial Experince & Skills.
            </h2>
          </header>
          <h4>
          <p>EXPERIENCE</p>
          
          <p>Present - (Backend Developer) @ TradeBrains &nbsp;&nbsp; &nbsp; - Bangalore</p>
          <p>Pegasus Equipments Private Limited (Software Developer) &nbsp;&nbsp; &nbsp; - Bangalore</p>
          <p>Total working Experince : 2 years</p>
          <hr/>
          <p>* Built Web application using Python, Django, JavaScript, JQuery, HTML and template languages to design server
          applications and client interfaces.</p>
          <p>* Good experience in developing web applications implementing Model,View,Forms Control architecture using 
          Python/Django web application framework.</p>
          <p>* Deployed Django applications on AWS and Digital Ocean and configured Nginx ,gunicorn,supervisor.</p>
          <p>* Optimised SQL quires and database indexes for large database,which improved data loading speed.</p>
          <p>* Curreently Working On Build various Fintech products like portfolio analysis, portfolio backtesting, also affiliate 
                and coupon link system on Django/Python,JavaScript,Ajax,Html.</p><br/>
        
          </h4>
          <hr/>
          <h2>Skills</h2>

          <h4>Backend</h4>
              <strong>Python :</strong>
              <div className="myProgress">
                <div id="myBar">75%</div>
              </div>
              <strong>Django :</strong>
              <div className="myProgress">
                <div id="django">80%</div>
              </div>
              <strong>Mysql :</strong>
              <div className="myProgress">
                <div id="mysql">60%</div>
              </div><br/>

          <h4>Cloud</h4>
              <strong>AWS/Digital Ocean :</strong>
              <div className="myProgress">
                <div id="react">50%</div>
              </div>
              <strong>Nginx/Gunicorn :</strong>
              <div className="myProgress">
                <div id="react">50%</div>
              </div> <br/>             

          <h4>Frontend</h4>
              <strong>React JS :</strong>
              <div className="myProgress">
                <div id="react">50%</div>
              </div>
              <strong>JavaScript/JQuery :</strong>
              <div className="myProgress">
                <div id="js">60%</div>
              </div>              
              <strong>Bootstrap/Css :</strong>
              <div className="myProgress">
                <div id="html">70%</div>
              </div><br/>
      

              <strong>Git :</strong>
              <div className="myProgress">
                <div id="git">40%</div>
              </div>
              <strong>Seo :</strong>
              <div className="myProgress">
                <div id="git">40%</div>
              </div>
        </section>

        <section>
        <h2>Founded Developer Stacks</h2>
        <p>Visit: <a href='https://developerstacks.com/'>Developer Stacks</a></p>
        <p>DeveloperStacks is much more than a stack website.
          I contribute my technical knowledge and excellent content on my personal platform blog site. 
          The goal of this site is to help the Developers community grow.</p>

          <h4>Stack Used</h4>
          <div>
            <h5>Backend: Django/Python/Django Rest Framework</h5>
            <h5>Frontend: Bootstrap/Html/Css/JavaScript/JQuery</h5>
            <h5>Server : Digital Ocean/Nginx/Gunicorn/Superviour/cronjob</h5>
            <h5>Libraries : allauth/Disqus(commet)/ckeditor/Beautiful soup /</h5>
            <h5>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; Emailmessage/Anymail(sendinblue,mailchimp,buymeacoffee)/
                            </h5>
            <h5>Seo: Sitemaps/robots.txt/Semantic Tags/Meta Tags/Google site verification/Site Performance</h5>
            <h5>Security: SSL/Http;Https/Secure Cookies;CSRF/Backend Security</h5>
          </div>
          
        </section>

        <section id="two">
          <h2>Personal Projects</h2>

          <Gallery />

          <ul className="actions">
            <li>
              {/* <a href="#" className="button"> */}
                ** Only Few Projects Mentioned **
              {/* </a> */}
            </li>
          </ul> 
        </section>

        <section>
        <h2>Certificates</h2>
          Python & Django (08/2019 – 11/2019)<br/>
          <p>Python Core & Advance and Django From Mytectra Institute</p>
        </section>

        <section>
  
        <h2>EDUCATION</h2>
          <h4>Bachelors of Computer Application</h4>
          <span>NRI Institute</span>
          06/2016 – 07/2019  &nbsp;&nbsp;&nbsp;&nbsp; - Bangalore University<br/><br/>

          <h4>Diploma</h4>
          RES Polytechnic<br/>
            
          Computer Science &nbsp;&nbsp;&nbsp;&nbsp;- Bangalore<br/>
        </section>

        <section id="three">
          <h2>Get In Touch</h2>
          <p>
            Please Find Here Contact Information <br/>
            {/* Also You can make direct mail/call on below details. <br/> */}
            <br/>
            Thank You!!
          </p>
          <div className="row">
            <div className="8u 12u$(small)">
              {/* <form method="post" action="#">
                <div className="row uniform 50%">
                  <div className="6u 12u$(xsmall)">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Name"
                    />
                  </div>
                  <div className="6u 12u$(xsmall)">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email"
                    />
                  </div>
                  <div className="12u">
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Message"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                <ul className="actions" style={{ marginTop: 30 }}>
                  <li>
                    <input type="submit" value="Send Message" />
                  </li>
                </ul>
              </form> */}
            </div>
            <div className="4u 12u$(small)">
              <ul className="labeled-icons">
                <li>
                  <h3 className="icon fa-home">
                    <span className="label">Address</span>
                  </h3>
                  Nagarbhavi
                  <br />
                  Bangalore-560091
                  <br />
                  Karnataka
                </li>
                <li>
                  <h3 className="icon fa-mobile">
                    <span className="label">Phone</span>
                  </h3>
                  8792973697
                </li>
                <li>
                  <h3 className="icon fa-envelope-o">
                    <span className="label">Email</span>
                  </h3>
                  <a href="https://mail.google.com/">ajayjangid1708@gmail.com</a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default HomeIndex
